import { Component } from "react"
import { toast } from "react-toastify"
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap"
import { RouteComponentProps } from "react-router"
import { Subscription, forkJoin } from "rxjs"
import ServicesSelection from "./ServicesSelection"
import DonorInformation from "./DonorInformation"
import Schedule from "./Schedule"
import SiteSearch from "../SiteSearch/SiteSearch"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"
import OrderedServices from "./OrderServices/OrderedServices"
import { ServiceDataModel, DonorInformationModel, ScheduleModel, OTHER_REASON_TEXT, GetRegulatoryModeDonor, ServiceOrderedModel } from "./OrderModels"
import OrderRequestsHeader, { StepData } from "./OrderRequestsHeader"
import OrderSubmitObservable from "../../api/OrderRequests/OrderSubmit"
import SelectionInboxGridRow from "../../api/Randoms/SelectionInboxModel/SelectionInboxGridRow"
import PotentialDonorMatchModal from "./PotentialDonorMatchModal"
import FormatDate from "../../formatters/FormatDate"
import FormatPhone from "../../formatters/FormatPhone"
import ActionButton from "../ActionButton"
import CompanyInput from "../FormattedInputs/CompanyInput"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"

import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import { TestReasonsObservable, RegulatoryModeObservable } from "../../api/OrderRequests/OrderRequestsConstraintGet"
import { TestReasonType } from "../../api/OrderRequests/OrderRequestsModel/TestReasonType"
import { AdvanceSearchDonorGetObservable } from "../../api/OrderRequests/SearchDonorGet"
import { Donor } from "../../api/OrderRequests/OrderRequestsModel/Donor"
import OrderData from "../../api/OrderRequests/OrderRequestsModel/OrderData"
import SaveOrder from "../../api/OrderRequests/OrderRequestsModel/SaveOrder"
import { EmailRegexp, EventType, StorageKey } from "../../config/Constants"
import { AlcoholTestSampleType } from "../../api/OrderRequests/OrderRequestsModel/AlcoholTestSampleType"
import { FaChevronRight } from "react-icons/fa"
import { OrderFinishRoute, SSOOrderFinishRoute } from "../../config/Routes"
import ServicesGet, { ServiceTypesGet, AccountServicesGet } from "../../api/Administration/OrderableServices"
import ServiceType, { IsServiceTypeCodeAlcohol, IsServiceTypeCodeDrug, IsServiceTypeCodePhysical, IsServiceTypeCodeBackground, IsServiceTypeCodeOHS, IsServiceTypeCodeCHS } from "../../api/Administration/Model/ServiceType"
import Service, { IsServiceCodePOCT, IsServiceCodeFLEX } from "../../api/Administration/Model/Service"
import AccountService from "../../api/Administration/Model/AccountService"
import Checkbox from "../Checkbox"
import { GetOrderRequest, SSOOrderRequestData, GetOrderRequestData  } from "../../api/OrderRequests/SSOOrderRequest"
import { GetSSOToken } from "../../storage/AuthToken"
import { APIError } from "../../api/ObservableFromFetch"
import ConfirmationModal from "../ConfirmationModal"
import { AutoFilterLocationsGet } from "../../api/Location/AutoFilterLocationsGet"
import { AppState } from "../../AppState"
import { connect } from "react-redux"
import { GetSelectedAssignedClinic } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import OrderDefaultsGet, { OrderDefault } from "../../api/Administration/OrderDefaults"
import LocationInput from "../FormattedInputs/LocationInput"
import { FullBaseUrl } from "../../api/ApiUrl"
import RegulatoryMode from "../../api/LabService/LabServiceModel/RegulatoryMode"
import EmployeeCategory from "../../api/LabService/LabServiceModel/EmployeeCategory"
import { DefaultLookupCode } from "../../api/LookupCodes/DefaultLookupCode"
import { ServiceCode } from "../../api/LookupCodes/ServiceCode"

interface OrderRequestProps {
  location: {
    state?: {
      formData?: SelectionInboxGridRow[]
    }
  }
}

interface OrderRequestAuthProps {
  isLocation?: boolean
}

interface OrderRequestData {
  issuerType: string
  company?: string
  location?: string
  selectedCompany?: AutoFilterCompany
  selectedLocation?: AutoFilterCompany
  regulatoryModeObj?: RegulatoryMode
  categoryObj?: EmployeeCategory
  reasonObj?: TestReasonType
  reasonOther?: string
  reason?: string
  donor: DonorInformationModel
  services: ServiceDataModel[]
  clinic?: CollectionSite
  schedule: ScheduleModel
}

interface OrderRequestState extends OrderRequestData {
  formKey: string
  step: number
  isDonorInfoSuccess: boolean
  showSiteSearch: boolean
  showPotentialMatches: boolean
  potentialDonorMatchList: Donor[]
  nextServiceID: number,
  isDonorValid: boolean
  isServicesConfirmed: boolean
  reasonsLoading: boolean
  defaultsLoading: boolean
  defaults: OrderDefault[]
  pendingDefaults: OrderDefault[]
  reasons: TestReasonType[]
  filteredReasons: TestReasonType[]
  idTypes: GetRegulatoryModeDonor[],
  orderSubmitting: boolean
  submittedOrder: boolean
  orderableServiceTypes: ServiceType[]
  orderableServices: Service[]
  orderableAccountServices: AccountService[],
  allowDonorClinicSelect: boolean
  ssoOrderRequest?: SSOOrderRequestData
  defaultAddress?: string
  showDrugWarning: boolean
  showLocations: boolean
  email?: string
  emailValid: boolean
}

export interface TestData {
  eventType: string
  dot: boolean
  testDetailID: string
  labAccountNumber?: string
  panelID?: number
  regulatoryModeID?: number
  employeeCategoryID?: number
}

export interface DonorData {
  PersonID: number
  FirstName: string
  LastName: string
  DonorID: string
  IDType: string
  MockDonorID: string
}

const IssuerTypeIndividual = "individual"
const RandomReason = "Random"
const FMCSARegulatoryMode = "FMCSA"
const DefaultExpirationHours: number = 72
const emptyDonor: DonorInformationModel = {
  idType: undefined,
  idTypeObj: undefined,
  state: undefined,
  stateCode: undefined,
  donorId: undefined,
  firstName: undefined,
  middleInitial: undefined,
  lastName: undefined,
  eveningPhone: undefined,
  daytimePhone: undefined,
  birthdate: undefined
}
const emptySchedule: ScheduleModel = {
  timezone: undefined,
  overrideAllowed: false,
  hoursUntilExpires: undefined,
  expirationDate: undefined,
  formattedExpirationDate: "",
  displayExpirationDate: "",
  comment: "",
  proceedImmediately:false,
  extendExpirationHours: 0
}
const emptyData: OrderRequestData = {
  issuerType: IssuerTypeIndividual, // In Angular app for Non-MCP users it is only choice and it is selected by default
  company: undefined,
  location: undefined,
  selectedCompany: undefined,
  reasonObj: undefined,
  reasonOther: undefined,
  reason: undefined,
  donor: { ...emptyDonor },
  services: [],
  clinic: undefined,
  schedule: { ...emptySchedule }
}

const buildOrderRequestData = (orderFormData?: SelectionInboxGridRow[]) => ({
  ...emptyData,
  company: orderFormData ? orderFormData[0]?.CompanyName : undefined,
  location: orderFormData ? orderFormData[0]?.LocationName : undefined,
  reason: orderFormData ? RandomReason : undefined,
  donor: {
    ...emptyDonor,
    idType: orderFormData ? orderFormData[0]?.IDType : undefined,
    donorId: orderFormData ? orderFormData[0]?.DonorID : undefined,
  }
})

export class OrderRequest extends Component<OrderRequestProps & OrderRequestAuthProps, OrderRequestState> {
  orderRequestToken = GetSSOToken()
  showAlcoholSection: boolean = false
  showDrugSection: boolean = false
  showPhysicalSection: boolean = false
  showOHSSection: boolean = false
  showCHSSection: boolean = false
  completingPendingOrders: boolean = false
  drugTestData?: TestData
  alcoholTestData?: TestData
  orderFormData?: SelectionInboxGridRow[]
  donorData?: DonorData

  constructor(props: OrderRequestProps) {
    super(props)

    this.orderFormData = props.location.state?.formData
    if (this.orderFormData) {
      this.completingPendingOrders = true
      this.donorData = {
        PersonID: this.orderFormData[0].PersonID,
        FirstName: this.orderFormData[0].FirstName,
        LastName: this.orderFormData[0].LastName,
        DonorID: this.orderFormData[0].DonorID,
        IDType: this.orderFormData[0].IDType,
        MockDonorID: this.orderFormData[0].MockDonorID
      }
      this.orderFormData.forEach(data => {
        if (data.EventType === EventType.Urine || data.EventType === "SD") {
          this.showDrugSection = true
          this.drugTestData = {
            eventType: data.EventType,
            dot: data.DOT,
            testDetailID: data.TestDetailID,
            labAccountNumber: data.LabAccountNumber,
            panelID: data.PanelID,
            regulatoryModeID: data.RegulatoryModeID,
            employeeCategoryID: data.EmployeeCategoryID
          }
        } else if (data.EventType === EventType.Breath || data.EventType === EventType.Saliva) {
          this.showAlcoholSection = true
          this.alcoholTestData = {
            eventType: data.EventType,
            dot: data.DOT,
            testDetailID: data.TestDetailID,
            regulatoryModeID: data.RegulatoryModeID,
            employeeCategoryID: data.EmployeeCategoryID
          }
        }
      })
    } else {
      this.showDrugSection = true
      this.showAlcoholSection = true
      this.showPhysicalSection = true
      this.showOHSSection = true
      this.showCHSSection = true
      this.completingPendingOrders = false
    }

    const data = buildOrderRequestData(this.orderFormData)
    this.state = {
      ...data,
      formKey: "OrderRequestForm",
      step: 1,
      showSiteSearch: false,
      isDonorInfoSuccess: false,
      showPotentialMatches: false,
      potentialDonorMatchList: [],
      nextServiceID: 1,
      services: [],
      isDonorValid: false,
      isServicesConfirmed: false,
      reasonsLoading: false,
      defaultsLoading: false,
      defaults: [],
      pendingDefaults: [],
      reasons: [],
      filteredReasons: [],
      idTypes: [],
      submittedOrder: false,
      orderSubmitting: false,
      orderableServiceTypes: [],
      orderableServices: [],
      orderableAccountServices: [],
      showDrugWarning: false,
      showLocations: false,
      emailValid: true,
      allowDonorClinicSelect: false
    }
  }

  subscriptions = new Subscription()
  advanceSearchDonorSubscription?: Subscription
  loaInitialDataSubscription?: Subscription
  loadAccountServicesSubscription?: Subscription
  loadLocationsSubscription?: Subscription

  componentDidMount() {
    this.loadInitialData()

    if (this.isSSO()) {
      this.subscriptions.add(
        GetOrderRequest(this.orderRequestToken).subscribe(
          data => this.parseOrderRequest(data.RequestText),
          error => this.handleAPIError(error, {})
        )
      )
    }
  }

  parseOrderRequest = (text: string) => {
    const request: SSOOrderRequestData = JSON.parse(text)
    this.setState({ ssoOrderRequest: request, defaultAddress: this.formatAddress(request) })
  }

  formatAddress = (ssoOrderRequest: SSOOrderRequestData) => {
    const address = ssoOrderRequest?.Donor?.Address
    return address ? `${address.Line1}, ${address.City} ${address.State}` : ""
  }

  isSSO = () => {
    return this.orderRequestToken !== ""
  }

  loadInitialData() {
    this.loaInitialDataSubscription && this.loaInitialDataSubscription.unsubscribe()
    this.setState({ reasonsLoading: true })
    this.loaInitialDataSubscription = forkJoin({
      orderableServiceTypes: ServiceTypesGet(),
      orderableServices: ServicesGet(),
      reasons: TestReasonsObservable()
    }).subscribe(
      ({ orderableServiceTypes, orderableServices, reasons }) => {
        this.setState({ 
          orderableServiceTypes: orderableServiceTypes,
          orderableServices: orderableServices,
          reasons: reasons,
          filteredReasons: reasons,
          reasonsLoading: false,
          reasonObj: this.orderFormData && reasons.find(item => item.Description === RandomReason)
        })
      },
      (error) => this.handleAPIError(error, { companiesLoading: false, reasonsLoading: false })
    )
  }

  loadAllDefaults = (accountID: number) => {
    if (this.completingPendingOrders || this.orderFormData) {
      return
    }
    this.setState({ defaultsLoading: true })
    this.subscriptions.add(
      OrderDefaultsGet({ ImplementationID:  0, AccountID: accountID, LookupCode: "" }).subscribe(
        data => {
          this.populateDefaults(data)
          this.setState({ defaults: data, defaultsLoading: false }, () => this.filterFields())
        },
        error => this.handleAPIError(error, { defaultsLoading: false })
      )
    )
  }
  loadPendingDefaults = (accountID: number) => {
    if (!this.completingPendingOrders || accountID <= 0) {
      return
    }
    this.setState({ defaultsLoading: true })
    this.subscriptions.add(
      OrderDefaultsGet({ ImplementationID: 0, AccountID: accountID, LookupCode: "" }).subscribe(
        data => {
          this.populateDefaults(data)
          this.setState({ pendingDefaults: data, defaultsLoading: false })
        },
        error => this.handleAPIError(error, { defaultsLoading: false })
      )
    )
  }

  populateDefaults = (defaults: OrderDefault[]) => {
    if (!Array.isArray(defaults)) {
      return
    }
    this.populateDefaultExpTime(defaults)

  }

  populateDefaultExpTime = (defaults: OrderDefault[]) => {
    if (!Array.isArray(defaults)) {
      return
    }
    let defaultExpTime = defaults.find(item => item.LookupCode === DefaultLookupCode.ExpTime && !!item.AccountID)
    if (!defaultExpTime) {
      defaultExpTime = defaults.find(item => item.LookupCode === DefaultLookupCode.ExpTime && !item.AccountID)
    }
    if (!defaultExpTime) {
      let accountId = 0
      const selectedCompany = this.state.selectedCompany
      if (selectedCompany) {
        accountId = selectedCompany.AccountID
      }
      defaultExpTime = {
        OrderDefaultID: 0,
        ImplementationID: 0,
        AccountID: accountId,
        LookupCode: DefaultLookupCode.ExpTime,
        FieldName: "",
        DefaultValue: DefaultExpirationHours.toString(),
        Show: false,
        IsDefault: false,
        Disable: false
      }
      defaults.push(defaultExpTime)
    }
    const defaultValue = defaultExpTime.DefaultValue || ""
    if (defaultValue === "") {
      defaultExpTime.DefaultValue = DefaultExpirationHours.toString()
    }
  }

  filterFields = () => {
    let reasonsDefaults = this.state.defaults.filter(item => item.LookupCode === DefaultLookupCode.TestReason && !!item.AccountID)
    if (reasonsDefaults.length === 0) reasonsDefaults = this.state.defaults.filter(item => item.LookupCode === DefaultLookupCode.TestReason && !item.AccountID)
    if (reasonsDefaults.length > 0) {
      let filteredReasons: TestReasonType[] = []
      const defaultReason = reasonsDefaults.find(item => !!item.Show && !!item.IsDefault)
      this.state.reasons.forEach((item, index) => {
        const def = reasonsDefaults.find(el => el.FieldName === item.Description)
        if (!def || def?.Show) filteredReasons.push(item)
      })
      this.setState({ filteredReasons: filteredReasons })
      if (defaultReason) this.onReasonChange(defaultReason.FieldName)
    }
    else {
      this.setState({ filteredReasons: [...this.state.reasons], })
    }
  }

  defaultExpirationTime = () => {
    let defaults = this.state.defaults
    if (this.completingPendingOrders) {
      defaults = this.state.pendingDefaults
    }
    let def = defaults.find(item => item.LookupCode === DefaultLookupCode.ExpTime && !!item.AccountID)
    if (!def) {
      def = defaults.find(item => item.LookupCode === DefaultLookupCode.ExpTime && !item.AccountID)
    }
    return def
  }

  loadAccountServices = (implementationID: number, accountID?: number) => {
    this.loadAccountServicesSubscription && this.loadAccountServicesSubscription.unsubscribe()
    let accountServices: AccountService[] = []
    this.loadAccountServicesSubscription = AccountServicesGet(implementationID, accountID).subscribe(
      data => {
        if (data?.length) {
          accountServices = data
        }
        else {
          if (accountID) {
            this.loadAccountServices(implementationID)
          }
          else {
            accountServices = this.state.orderableServices.map(service => { return { AccountServiceID: 0, ImplementationID: implementationID, ServiceID: service.ServiceID, Active: false, IsDefault: false } })
          }
        }
        if (accountServices.length) {
          this.setState({ orderableAccountServices: accountServices, services: [], isServicesConfirmed: false })
        }
      },
      (error) => this.handleAPIError(error, {})
    )
  }

  loadLocations = (accountID: number) => {
    this.loadLocationsSubscription && this.loadLocationsSubscription.unsubscribe()
    this.loadLocationsSubscription = AutoFilterLocationsGet(accountID, "", true).subscribe(
      data => {
        const showLocations = data.length > 0
        if (this.props.isLocation) {
          const locationName = this.state.location || data[0]?.Name || ""
          this.setState({ showLocations: showLocations, location: locationName })
        }
        else {
          this.setState({ showLocations: showLocations })
        }
      },
      error => this.handleAPIError(error, { companiesLoading: false })
    )
  }

  componentWillUnmount() {
    this.subscriptions.unsubscribe()
    this.advanceSearchDonorSubscription && this.advanceSearchDonorSubscription.unsubscribe()
    this.loaInitialDataSubscription && this.loaInitialDataSubscription.unsubscribe()
    this.loadAccountServicesSubscription && this.loadAccountServicesSubscription.unsubscribe()
    this.loadLocationsSubscription && this.loadLocationsSubscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  resetForm = () => {
    const data = buildOrderRequestData(this.orderFormData)
    const company = data.company || this.state.selectedCompany?.Name || ""
    const selectedCompany = company ? this.state.selectedCompany : undefined
    const reasonObj = data.reason ? this.state.reasons.find(item => item.Description === data.reason) : undefined
    const idTypeObj = data.donor.idType ? this.state.idTypes.find(item => item.PrimaryIDType === data.donor.idType) : undefined

    this.setState({
      ...data,
      formKey: Math.random().toString(),
      company: company,
      selectedCompany: selectedCompany,
      reasonObj: reasonObj,
      clinic: undefined,
      donor: { ...data.donor, idTypeObj: idTypeObj },
      step: 1,
      showSiteSearch: false,
      isDonorInfoSuccess: false,
      showPotentialMatches: false,
      potentialDonorMatchList: [],
      nextServiceID: 1,
      isDonorValid: false,
      isServicesConfirmed: false,
      submittedOrder: false,
      orderSubmitting: false
    })
  }

  onCompanyChange = (companies: AutoFilterCompany[]) => {
    const selectedCompany = companies[0]
    if (selectedCompany) {
      this.loadAccountServices(selectedCompany?.ImplementationID || 0, selectedCompany.AccountID)
      this.loadAllDefaults(selectedCompany.AccountID)
      this.loadPendingDefaults(selectedCompany.AccountID)
      this.setState({ company: selectedCompany?.Name, selectedCompany: selectedCompany, showLocations: false, selectedLocation: undefined, reasonObj: (this.orderFormData ? this.state.reasonObj : undefined), reason: (this.orderFormData ? this.state.reason : undefined), reasonOther: undefined })
      this.loadLocations(selectedCompany.AccountID)
    }
    else {
      this.setState({ selectedCompany: selectedCompany, reasonObj: undefined, reason: undefined, reasonOther: undefined, services: [], orderableAccountServices: [], isServicesConfirmed: false })
    }
  }

  onLocationChange = (locations: AutoFilterCompany[]) => {
    const selectedLocation = locations[0]
    this.setState({ selectedLocation: selectedLocation })
    if (selectedLocation) {
      this.setState({ selectedLocation: selectedLocation, services: [], isServicesConfirmed: false })
    }
    else {
      this.setState({ selectedLocation: selectedLocation })
    }
  }

  onReasonChange = (value: string) => {
    const reasonObject = this.state.reasons?.find((item: TestReasonType) => item.Description === value)
    this.setState({ reason: reasonObject?.Description, reasonObj: reasonObject, submittedOrder: false })
  }
  onDonorChange = (donor: DonorInformationModel, isValid: boolean, isDonorInfoSuccess: boolean) => this.setState({ donor: donor, isDonorValid: isValid, isDonorInfoSuccess: isDonorInfoSuccess, submittedOrder: false, email: donor.email })
  onScheduleChange = (schedule: ScheduleModel) => this.setState({ schedule: schedule, submittedOrder: false })

  hasDragService = (services: ServiceDataModel[], isDot: boolean) => services.find(service => IsServiceTypeCodeDrug(service.serviceTypeCode) && service.isDOT === isDot)

  onAddService = (data: ServiceDataModel) => {
    // Add service to list
    // Reset confirmation status
    const { services, nextServiceID } = this.state
    
    let newServices = [ ...services ]
    let newServiceID = nextServiceID

    if(data.selectedServices.length > 0) {
      data.selectedServices.map((service) => {
        if (!newServices.find((s) => s.serviceCode === service.FFServiceCode)){
          newServices.push({
            ...data,
            id: newServiceID++,
            serviceCode: service.FFServiceCode as ServiceCode,
            isDOT: service.DOT,
            isMarketplace: service.Marketplace,
          })
        }
      })
    } else {
      newServices = [...services, ...[{...data, id: newServiceID++}]]
    }
    
    const showDrugWarning = 
      IsServiceTypeCodeDrug(data.serviceTypeCode) &&
      !!this.hasDragService(services, true) && !!this.hasDragService(services, false) &&
      (!this.hasDragService(this.state.services, true) || !this.hasDragService(this.state.services, false))

    const modeObj = !!this.state.regulatoryModeObj ? this.state.regulatoryModeObj : data.regulatoryModeObj
    const catObj = !!this.state.categoryObj ? this.state.categoryObj : data.categoryObj

    this.setState({
      showDrugWarning: showDrugWarning,
      nextServiceID: newServiceID,
      services: newServices,
      isServicesConfirmed: false,
      submittedOrder: false,
      regulatoryModeObj: modeObj,
      categoryObj: catObj,
    })
  }

  onRemoveService = (id: number) => {
    // Remove service from list
    // Reset confirmation status
    const services = this.state.services.filter(item => item.id !== id)

    if (services.length === 0) {
      this.setState({ services: services, isServicesConfirmed: false, submittedOrder: false, regulatoryModeObj: undefined, categoryObj: undefined })
    }
    {
      this.setState({ services: services, isServicesConfirmed: false, submittedOrder: false })
    }
  }

  onConfirmServices = () => this.setState({ isServicesConfirmed: true })

  // Navigation methods
  onCancel = () => {
    localStorage.removeItem(StorageKey.SavedOrderData)
    localStorage.removeItem(StorageKey.OrderedServices)
    localStorage.removeItem(StorageKey.CanViewOrderFinish)
    if (this.props.location.state?.formData) {
      (this.props as RouteComponentProps).history.goBack()
    } else {
      this.resetForm()
    }
  }

  handleAllowDonorClinicSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const lastValue = this.state.allowDonorClinicSelect
    if(!this.isSSO()){
      this.setState({ allowDonorClinicSelect: event.target.checked, schedule: (lastValue ?  { ...emptySchedule } : this.state.schedule)})
      return
    }
    let donor_email = this.state.email || ""
    if(donor_email === ""){
        donor_email = this.state.ssoOrderRequest?.Donor?.Donoremail || ""
    } 
    this.setState({ 
      allowDonorClinicSelect: event.target.checked, schedule: (lastValue ?  { ...emptySchedule } : this.state.schedule),
      email: donor_email, emailValid: this.isEmailValid(donor_email)
   })
  }

  getIdTypes = () => {
    this.subscriptions.add(
      RegulatoryModeObservable(this.regulatoryModeFromServices()).subscribe(
        results => this.setState({ idTypes: results }),
        error => toast.error(error)
      )
    )
  }

  onGoToStep1 = () => this.setState({ step: 1 })
  onGoToStep2 = () => {
    this.setState({ step: 2 })
    this.getIdTypes()
  }

  onSubmit = () => {
    if (this.state.isDonorInfoSuccess) {
      this.saveOrder()
    }
    else {
      this.advanceSearchDonorSubscription && this.advanceSearchDonorSubscription.unsubscribe()
      const params = {
        CompanyID: this.state.selectedCompany?.AccountID || 0,
        DayTimePhone: this.state.donor?.daytimePhone || "",
        EveningPhone: this.state.donor?.eveningPhone || "",
        Mobile: null,
        RegulatoryModeID: this.regulatoryModeFromServices(),
        LastName: this.state.donor?.lastName,
        DateOfBirth: this.state.donor?.birthdate ? FormatDate(this.state.donor?.birthdate) : undefined
      }
      this.advanceSearchDonorSubscription = AdvanceSearchDonorGetObservable(params).subscribe(
        (response: Donor[]) => {
          if (response.length) {
            this.setState({ potentialDonorMatchList: response, showPotentialMatches: true })
          }
          else {
            this.saveOrder()
          }
        },
        (error: string) => toast.error(error)
      )
    }
  }

  // TODO: Verify logic src\app\pages\order\order.component.ts:2793
  regulatoryModeFromServices = () => this.state.services.find(item => item.isDOT && item.regulatoryModeObj)?.regulatoryModeObj?.RegulatoryModeID || 0
  categoryFromServices = () => this.state.services.find(item => item.isDOT && item.categoryObj)?.categoryObj?.EmployeeCategoryID || 0

  saveOrder() {
    const formatPhone = (phone?: string) => {
      if (!phone || phone === "np" || phone === "n/p" || phone === "NP" || phone === "N/P") {
        return "N/P"
      }
      return phone.replace(/-/g, "")
    }

    const formatDate = (date?: Date) => {
      if (!date) {
        return ""
      }
      return FormatDate(date)
    }

    const order: SaveOrder = {
      MultipleDrug: [],
      MultipleAlcohol: this.state.services.filter(service => IsServiceTypeCodeAlcohol(service.serviceTypeCode)).map((service) => { return { DOT: !!service.isDOT, SampleTypeID: (service.testToPerformObj as AlcoholTestSampleType).SampleTypeID } }),
      MultiplePOCT: [],
      MultipleClinical: [],
      MultiplePhysical: {},
      POCTCount: 0,
      CollectionVendorID: this.state.clinic?.VendorID || "",
      FormFoxVendorAN: this.state.clinic?.FormFoxVendorAN || 0,
      Collector: {
        VendorID: this.state.clinic?.VendorID || 0,
        ParentVendorID: this.state.clinic?.ParentVendorID || null,
        FFID: this.state.clinic?.FFID || "",
        Name: this.state.clinic?.Name || "",
        Code: this.state.clinic?.Code || "",
        Type: this.state.clinic?.Type || null,
        Address1: this.state.clinic?.Address1 || "",
        Address2: this.state.clinic?.Address2 || "",
        City: this.state.clinic?.City || "",
        State: this.state.clinic?.State || "",
        Zip: this.state.clinic?.Zip || "",
        Phone: this.state.clinic?.Phone || "",
        HoursOfOperation: this.state.clinic?.HoursOfOperation || "",
        Private: this.state.clinic?.Private || false,
        Distance: this.state.clinic?.Distance || 0,
        Latitude: this.state.clinic?.Latitude || 0,
        Longitude: this.state.clinic?.Longitude || 0,
        UseDOTForm: this.state.clinic?.UseDOTForm || false,
        FFEnabled: this.state.clinic?.FFEnabled || false,
        OutOfNetwork: this.state.clinic?.OutOfNetwork || false,
        iVendorID: this.state.clinic?.iVendorID || 0,
        SiteID: this.state.clinic?.SiteID || null,
        Fax: this.state.clinic?.Fax || "",
        IsMarketPlace: this.state.clinic?.IsMarketPlace || false,
      },
      CollectorPhone: null,
      CollectorVendorName: this.state.clinic?.Name || "",
      ConfirmDeviceCode: "",
      ConfirmDeviceDescription: "",
      ConfirmDeviceExpirationDate: null,
      ConfirmDeviceID: null,
      ConfirmDeviceSerialNumber: "",
      EventData: {
        AccountID: this.state.selectedCompany?.AccountID || 0,
        CompanyID: this.state.selectedCompany?.AccountID || 0,
        CompanyCode: this.state.selectedCompany?.Code || "",
        CompanyFullName: this.state.selectedCompany?.Code ? `${this.state.selectedCompany?.Name || ""} (${this.state.selectedCompany?.Code || ""})` : "",
        CompanyName: this.state.selectedCompany?.Name || "",
        DateOrdered: "",
        DateScheduled: "",
        ExpirationDate: this.state.schedule.formattedExpirationDate,
        LocationID: this.state.selectedLocation?.AccountID.toString() || "",
        PrimaryID: (this.state.donor.donorId || "").replace(/-/g, ""),
        PrimaryIDRank: this.state.donor.idTypeObj?.Rank || 0,
        PrimaryIDType: this.state.donor.idTypeObj?.PrimaryIDType || "",
        RegulatoryModeID: this.regulatoryModeFromServices(),
        EmployeeCategoryID: this.categoryFromServices(),
        RegionID: "",
        RegionName: "",
        TimeZone: this.state.schedule.timezone,
        AllowDonorClinicSelect: this.state.allowDonorClinicSelect || false,
        ProceedImmediately: this.state.schedule.proceedImmediately,
        ExtendExpirationHours: this.state.schedule.extendExpirationHours || 0
      },
      Panel: {
        PanelID: "",
        Description: "",
        Code: "",
        ClientID: "",
        BeginEffectiveDate: "",
        EndEffectiveDate: "",
        UserLogin: "",
        UpdateMethod: "",
        UpdateDate: ""
      },
      PanelDescription: "",
      IsAlcohol: "",
      IsAssociatedWithPool: false,
      IsCompleted: false,
      IsDrug: "",
      IsBackground: false,
      IsNew: false,
      IsPhysical: false,
      IsAudiogram: false,
      IsPoct: false,
      IsRandom: false,
      IsReleased: false,
      LaboratoryVendorCode: "",
      LaboratoryVendorID: "",
      LaboratoryVendorName: "",
      LabPanelID: 0,
      TestReasonID: this.state.reasonObj?.TestReasonID || 0,
      TestReasonDescription: this.state.reasonObj?.Description || "",
      TestTypeDescription: this.state.services.some(item => IsServiceTypeCodeDrug(item.serviceTypeCode)) ? "Drug" : "",
      TestTypeID: this.state.services.some(item => IsServiceTypeCodeDrug(item.serviceTypeCode)) ? 1 : 0,
      SampleTypeID: "",
      SampleTypeDescription: "",
      Labbased: this.state.services.some(item => IsServiceTypeCodeDrug(item.serviceTypeCode)),
      OrderComment: this.state.schedule.comment,
      SplitSpecimen: "",
      Observed: "",
      DOT: this.state.services.some(item => item.isDOT),
      Normal: "",
      SampleTypeCode: "",
      PersonDetail: {
        PersonID: this.state.donor.personId || 0,
        DateOfBirth: formatDate(this.state.donor.birthdate),
        HomePhone: formatPhone(this.state.donor.eveningPhone),
        CellPhone: "",
        WorkPhone: formatPhone(this.state.donor.daytimePhone),
        MiddleInitial: (this.state.donor.middleInitial || "").substring(0,1),
        AlternateID: "",
        DriverID: "",
        EmployerID: "",
        SSN: "",
        FirstName: this.state.donor.firstName || "",
        LastName: this.state.donor.lastName || "",
        CCFPersonnelID: (this.state.donor.donorId || "").replace(/-/g, ""),
        MockCCFPersonnelID: this.orderFormData ? this.orderFormData[0].MockDonorID : "",
        DriverLicStateOfIssue: this.state.donor?.stateCode || this.state.donor?.state?.Abbreviation || "",
        Email: this.state.email || ""
      },
      MockAlcoholTestDetailID: this.alcoholTestData?.testDetailID || "",
      MockDrugTestDetailID: this.drugTestData?.testDetailID || "",
      PoolMembersID: this.orderFormData ? this.orderFormData[0]?.PoolMembersID : undefined,
      SSOToken: this.orderRequestToken,
      BaseUrl:  FullBaseUrl(),
    }

    if (this.orderRequestToken) {
      order.PersonDetail.Address = this.state.donor.address
    }

    if (this.state.services.some(item => IsServiceTypeCodePhysical(item.serviceTypeCode))) {
      order.MultiplePhysical.DOT = this.state.services.find(item => IsServiceTypeCodePhysical(item.serviceTypeCode))?.isDOT
      order.IsPhysical = true
    }

    this.state.services.filter(service => IsServiceTypeCodeDrug(service.serviceTypeCode)).forEach((service) => {
      const is_poct = IsServiceCodePOCT(service.serviceCode)
      const is_flex = IsServiceCodeFLEX(service.serviceCode)
      order.MultipleDrug.push(
        {
          DOT: !!service.isDOT,
          IsPoct: is_poct || is_flex,
          IsFlex: is_flex,
          SplitSpecimen: service.reqSpecimenCollection === "single" ? false : true,
          Observed: service.observedCollection,
          Normal: !service.observedCollection,
          RegulatoryModeID: service.regulatoryModeObj?.RegulatoryModeID || "",
          RegulatoryModeName: service.regulatoryModeObj?.Name || "",
          EmployeeCategoryID: service.categoryObj?.EmployeeCategoryID || "",
          EmployeeCategoryName: service.categoryObj?.Name || "",
          LabAccountNumber: service.labAccountObj?.LabAccount || "",
          LaboratoryVendorCode: service.labAccountObj?.LabCode || "",
          LaboratoryVendorID: service.labAccountObj?.LabClientMemberId || 0,
          LabPanelID: service.testToPerformObj?.PanelID || 0,
          PanelDescription: service.testToPerformObj?.Description || "",
          PanelCode: service.testToPerformObj?.Code || "",
          SampleTypeCode: service.testToPerformObj?.SampleTypeCode || "",
        }
      )
    })

    this.state.services.filter(service => IsServiceTypeCodeOHS(service.serviceTypeCode) || IsServiceTypeCodeCHS(service.serviceTypeCode)).forEach((service) => {
      order.MultipleClinical.push({
          DOT: !!service.isDOT,
          IsPoct: false,
          SplitSpecimen: false,
          Observed: false,
          Normal: true,
          RegulatoryModeID: "",
          RegulatoryModeName: "",
          EmployeeCategoryID: "",
          EmployeeCategoryName: "",
          LabAccountNumber: service.labAccountObj?.LabAccount || "",
          LaboratoryVendorCode: service.labAccountObj?.LabCode || "",
          LaboratoryVendorID: service.labAccountObj?.LabClientMemberId || 0,
          LabPanelID: service.testToPerformObj?.PanelID || 0,
          PanelDescription: service.testToPerformObj?.Description || "",
          PanelCode: service.testToPerformObj?.Code || "",
          ClinicalTestType: service.serviceCode,
          SelectedPanels:[]
      })
      const item = order.MultipleClinical[order.MultipleClinical.length - 1]
      const selectedTests = service.selectedTests || []
      for(let i = 0; i < selectedTests.length; i++){
        const panel = {
          LabPanelID: selectedTests[i].PanelID || 0,
          PanelDescription: selectedTests[i].Description || "",
          PanelCode: selectedTests[i].Code || "",
          PanelID: selectedTests[i].PanelID || 0,
          ClientID: selectedTests[i].ClientID || 0,
          Code: selectedTests[i].Code || "",
          Description: selectedTests[i].Description || "",
          DOT: !!selectedTests[i].DOT ,
          POCT: !!selectedTests[i].POCT,
          FLEX: !!selectedTests[i].FLEX,
          NDOT: !!selectedTests[i].NDOT,
          SampleTypeCode: selectedTests[i].SampleTypeCode || ""
        }
        item.SelectedPanels.push(panel)
        }
    })

    this.setState({ orderSubmitting: true })
    this.subscriptions.add(
      OrderSubmitObservable(order).subscribe(
        (results: OrderData) => {
          this.setState({ submittedOrder: true, orderSubmitting: false })
          this.saveSuccess(results)
        },
        error => {
          this.setState({ submittedOrder: false, orderSubmitting: false })
          toast.error(error)
        }
      )
    )
  }

  saveSuccess = (orderFinishData: OrderData) => {
    localStorage.setItem(StorageKey.SavedOrderData, JSON.stringify(orderFinishData))
    const isTest = true         // TODO: remove hard-coded value when Background test is added, remap to: isTest = (this.findLocationObj.IsDrug === true || this.findLocationObj.IsPoct === true || this.findLocationObj.IsAlcohol === true || this.findLocationObj.IsPhysical === true))
    const isBackground = false  // TODO: remove hard-coded value when Background test is added, remap to: isBackground = this.findLocationObj.IsBackground === true
    if (orderFinishData.FormFoxTestAN > 0 || orderFinishData.ProfileNumber) {
      if (orderFinishData.FormFoxTestAN === 0 && isTest) {
        toast.error(orderFinishData.FFresult)
      }
      if (!orderFinishData.ProfileNumber && isBackground) {
        toast.error(orderFinishData.CSresult)
      }

      localStorage.setItem(StorageKey.OrderedServices, JSON.stringify(this.normalizeOrderedServices()))
      localStorage.setItem(StorageKey.CanViewOrderFinish, JSON.stringify(true))
      localStorage.setItem(StorageKey.FromSelectionInbox, JSON.stringify(!!this.orderFormData))
      localStorage.setItem(StorageKey.OrderDonorSiteSelect, JSON.stringify(!this.state.clinic))

      const props = this.props as RouteComponentProps
      props.history.push(this.isSSO() ? SSOOrderFinishRoute : OrderFinishRoute)
    } else {
      if (isTest) {
        toast.error(orderFinishData.FFresult)
      }
      if (isBackground) {
        toast.error(orderFinishData.CSresult)
      }
    }
  }

  normalizeOrderedServices = (): ServiceOrderedModel[] => {
    return this.state.services.map(service => {
      const { serviceTypeCode, serviceCode, isDOT, testToPerform, testToPerformObj, labAccountObj } = service
      return { serviceTypeCode, serviceCode, isDOT, testToPerformDesc: testToPerformObj?.Description || testToPerform, labAccountDesc: labAccountObj?.Description }
    })
  }

  closePotentialDonorMatchModal = () => {
    //this.PersonID = 0
    toast.error("Donor was not found. New donor will be created.")
    this.setState({ showPotentialMatches: false }, () => this.saveOrder())
  }

  submitPotentialDonorMatchModal = (response: Donor) => {
    toast.success("Your Order will be placed with the selected ID Type.")
    const fetchedDate = response.DateOfBirth ? new Date(response.DateOfBirth) : undefined
    const validDate = fetchedDate && fetchedDate.getTime && !isNaN(fetchedDate.getTime())
    const newDonor: DonorInformationModel = {
      ...this.state.donor,
      personId: response.PersonID,
      firstName: response.FirstName,
      middleInitial: response.MiddleInitial,
      lastName: response.LastName,
      eveningPhone: FormatPhone(response.HomePhone),
      daytimePhone: FormatPhone(response.WorkPhone),
      birthdate: validDate ? fetchedDate : undefined,

      firstNameReadOnly: !!response.FirstName,
      middleInitialReadOnly: !!response.MiddleInitial,
      lastNameReadOnly: !!response.LastName,
      homePhoneReadOnly: !!(response.HomePhone && response.HomePhone !== "N/P"),
      workPhoneReadOnly: !!(response.WorkPhone && response.WorkPhone !== "N/P"),
      state: undefined,
      stateCode: response.DriverLICStateOfIssue ? response.DriverLICStateOfIssue : undefined
    }
    this.setState({
      donor: newDonor,
      showPotentialMatches: false
    }, () => this.saveOrder())
  }

  closeDrugWarning = () => this.setState({ showDrugWarning: false })

  isEmailValid = (value: string) => EmailRegexp.test(value)

  handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    this.setState({ email: value, emailValid: this.isEmailValid(value) })
  }

  render() {
    const { issuerType, company, reasonObj, reasonOther, submittedOrder, selectedCompany, clinic, showLocations } = this.state
    const isIssuerValid = !!issuerType && !!company && !!reasonObj && (reasonObj?.Description !== OTHER_REASON_TEXT || !!reasonOther)
    // Step 2 is available when services list is confirmed, company is set and reason is set
    const canGoToOrderFeatures = this.state.isServicesConfirmed && isIssuerValid
    const isStep2Available = this.state.step !== 2 && canGoToOrderFeatures
    const allowClinicSelectValid = (!!this.state.clinic && !this.state.allowDonorClinicSelect) || (this.state.allowDonorClinicSelect && (this.isSSO() || (this.state.emailValid && this.state.email && this.state.email !== "")))
    const isOrderCanBeSubmitted = canGoToOrderFeatures && this.state.isDonorValid && allowClinicSelectValid && !submittedOrder
    const isBirthDateRequired = this.state.services.filter(service => IsServiceTypeCodePhysical(service.serviceTypeCode) || IsServiceTypeCodeBackground(service.serviceTypeCode)).length > 0
    // Confirm button is enabled when at least one service is added to ordered services list and confirmation status is not set
    const canConfirm = this.completingPendingOrders ? this.state.services.length === this.orderFormData?.length && !this.state.isServicesConfirmed : this.state.services.length > 0 && !this.state.isServicesConfirmed
    const disableReason = this.state.services.length > 0 || !selectedCompany || this.state.defaultsLoading

    const headerSteps: StepData[] = [
      {
        title: '1',
        disabled: this.state.step === 1,
        current: this.state.step === 1,
        onClick: () => this.setState({ step: 1 })
      },
      {
        title: '2',
        disabled: !isStep2Available,
        current: this.state.step === 2,
        onClick: () => this.setState({ step: 2 })
      },
      {
        title: '3',
        disabled: true,
        current: this.state.step === 3,
        onClick: () => { }
      }
    ]

    //2022-09-29. Yanek Dogel. DFCT0011749 Donor Self Schedule does not work in conjunction with Embedded Ordering. 
    //Do not hide email for SSO. 
   
    return (<>
      <AppPageWrapper parentClassName="OrderRequest" showNav={true}>
        <PotentialDonorMatchModal
          potentialDonorMatchList={this.state.potentialDonorMatchList}
          show={this.state.showPotentialMatches}
          onClose={this.closePotentialDonorMatchModal}
          onSubmit={this.submitPotentialDonorMatchModal} />
        <Modal show={this.state.showSiteSearch} onHide={() => this.setState({ showSiteSearch: false })} size="xl" dialogClassName="dark modal-90w">
          <Modal.Header closeButton>
            <Modal.Title>SITE SEARCH</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SiteSearch
              accountID={this.state.selectedLocation?.AccountID || this.state.selectedCompany?.AccountID}
              tests={this.state.services}
              isSSO={this.isSSO()}
              defaultAddress={this.state.defaultAddress}
              onSiteSelect={site => this.setState({ clinic: site, showSiteSearch: false, submittedOrder: false })} 
            />
          </Modal.Body>
        </Modal>
        <ConfirmationModal 
          show={this.state.showDrugWarning} 
          title="CAUTION" text="Scheduling multiple Urine collections on the same order may cause extended wait time at the clinic for your donor. Call our support line if we can consult on this matter."
          showImage={false}
          showCancelButton={false}
          confirmButtonText="OK"
          onHide={this.closeDrugWarning}
          onConfirm={this.closeDrugWarning}
        />
        <Container fluid className="OrderRequests" key={this.state.formKey}>
          <Row>
            <Col md={12}>
              <Container fluid className="mb-4">
                <Row>
                  <Col xs={12} md={6} className="p-0 px-2 mx-1">
                    <OrderRequestsHeader steps={headerSteps} />
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
          <Row>
            <Col hidden={this.state.step !== 1}>
              <Container fluid>
                <Row>
                  <Col sm={12} md={6} lg={4}>
                    <span className="font-weight-bold">Do you want to order for?</span>
                    <Form>
                      <Form.Group>
                        <Form.Check inline label="An Individual"
                          type="radio"
                          value="individual"
                          className="font-weight-bold abc-radio"
                          checked={this.state.issuerType === 'individual'}
                          onChange={() => { }} />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="font-weight-bold">COMPANY</Form.Label>
                        <CompanyInput filter disabled={this.completingPendingOrders} defaultValue={this.state.company} onChange={this.onCompanyChange} />
                      </Form.Group>
                      {showLocations && <Form.Group>
                        <Form.Label className="font-weight-bold">LOCATION</Form.Label>
                        <LocationInput
                          hideInactive
                          filter
                          companyID={this.state.selectedCompany?.AccountID || 0}
                          defaultValue={this.state.location}
                          disabled={this.completingPendingOrders}
                          onChange={this.onLocationChange} />
                      </Form.Group>}
                      <Form.Group>
                        <Form.Label className="font-weight-bold required">REASON</Form.Label>
                        <Form.Control as="select" value={reasonObj?.Description || ""}
                          onChange={(e) => this.onReasonChange(e.target.value)}
                          isInvalid={this.state.selectedCompany && !this.state.reasonObj}
                          disabled={this.state.reasonsLoading || this.completingPendingOrders || disableReason}>
                          <option />
                          {this.state.filteredReasons.map((item: TestReasonType) => <option value={item.Description} key={item.TestReasonID}>{item.Description}</option>)}
                        </Form.Control>
                      </Form.Group>
                      <Form.Group hidden={this.state.reasonObj?.Description !== OTHER_REASON_TEXT}>
                        <Form.Label className="font-weight-bold required">OTHER REASON</Form.Label>
                        <Form.Control type="text"
                          value={this.state.reasonOther || ""}
                          isInvalid={!this.state.reasonOther}
                          onChange={(e) => this.setState({ reasonOther: e.target.value })} />
                      </Form.Group>
                    </Form>
                    <ServicesSelection services={this.state.services}
                      reason={this.state.reasonObj}
                      selectedRegMode={this.state.regulatoryModeObj}
                      selectedCategory={this.state.categoryObj}
                      completingPendingOrders={this.completingPendingOrders}
                      company={this.state.selectedCompany?.AccountID}
                      location={this.state.selectedLocation?.AccountID}
                      showDrugSection={this.showDrugSection && !!selectedCompany}
                      drugTestData={this.drugTestData}
                      showAlcoholSection={this.showAlcoholSection && !!selectedCompany}
                      alcoholTestData={this.alcoholTestData}
                      showPhysicalSection={this.showPhysicalSection && !!selectedCompany}
                      showOHSSection={this.showOHSSection && !!selectedCompany}
                      showCHSSection={this.showCHSSection && !!selectedCompany}
                      denyAddServices={!this.state.reasonObj}
                      maximumDrugTests={this.showDrugSection ? 1 : 0}
                      maximumAlcoholTests={this.showAlcoholSection ? this.completingPendingOrders ? 1 : 4 : 0}
                      maximumPhysicalTests={1}
                      orderableServiceTypes={this.state.orderableServiceTypes}
                      orderableServices={this.state.orderableServices}
                      orderableAccountServices={this.state.orderableAccountServices}
                      defaults={this.state.defaults}
                      onAddService={this.onAddService} />
                  </Col>
                  <Col sm={12} md={6} lg={8} className="d-flex align-items-center">
                    <OrderedServices services={this.state.services}
                      canConfirm={canConfirm}
                      canRemove={!this.completingPendingOrders}
                      onRemoveService={this.onRemoveService}
                      onConfirm={this.onConfirmServices} />
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col className="p-0" hidden={this.state.step !== 2}>
              <Container fluid>
                <Col xs={12} sm={12} md={6}>
                  <DonorInformation companyId={this.state.selectedCompany?.AccountID}
                    completingPendingOrders={!!this.orderFormData}
                    orderFormData={this.donorData}
                    donor={this.state.donor}
                    onDonorChange={this.onDonorChange}
                    isBirthDateRequired={isBirthDateRequired}
                    idTypes={this.state.idTypes}
                    regulatoryMode={this.state.regulatoryModeObj}
                    SSODonorData={this.isSSO() ? this.state.ssoOrderRequest?.Donor : undefined} />
                </Col>
                <Col>
                  <Form className="py-2">
                    <Form.Row>
                      <Form.Label column className={`font-weight-bold ${this.state.allowDonorClinicSelect ? "" : "required" }`}>Clinic</Form.Label>
                    </Form.Row>
                    <Form.Row hidden={!clinic}>
                      <Col xs={12} sm={4}>
                        <Form.Label className="font-weight-bold">{clinic?.Name}</Form.Label>
                      </Col>
                    </Form.Row>
                    <Form.Row hidden={!clinic}>
                      <Col xs={12} sm={4}>
                        <Form.Label>{clinic?.Address1} {clinic?.Address2} {clinic?.Zip}</Form.Label>
                      </Col>
                    </Form.Row>
                    {clinic && (!!clinic?.Phone || !!clinic?.Fax) && <Form.Row>
                      <Col xs={12} sm={4}>
                        {clinic?.Phone && <Form.Label className="pr-3">Phone: {FormatPhone(clinic?.Phone)}</Form.Label>}
                        {clinic?.Fax && <Form.Label>Fax: {FormatPhone(clinic?.Fax)}</Form.Label>}
                      </Col>
                    </Form.Row>}
                    <Form.Row className="pt-2">
                      <Col xs={4} sm={3}>
                        <Button variant="secondary" className="fixed-w10 btn-icon" onClick={() => this.setState({ showSiteSearch: true })}>
                          {this.state.clinic ? "CHANGE CLINIC" : "FIND CLINIC"}
                          <FaChevronRight />
                        </Button>
                      </Col>
                      <Col xs={6} sm={4} className="mt-2">
                        <Checkbox id="allow_select_clinic" label="Allow Donor to select Clinic" className="font-weight-bold"
                          checked={this.state.allowDonorClinicSelect} onChange={this.handleAllowDonorClinicSelect} />
                      </Col>
                    </Form.Row>
                    <Form.Row className="pt-2" hidden={!this.state.allowDonorClinicSelect}> 
                      <Col xs={2} sm={2}>
                        <Form.Label column className="font-weight-bold required">DONOR EMAIL</Form.Label>
                      </Col>
                      <Col xs={6} sm={4}>
                        <Form.Control id="email" size="sm" type="text" value={this.state.email || this.state.donor.email} onChange={this.handleEmailChange} isInvalid={!this.state.emailValid} className="rounded-pill" />
                        {!this.state.emailValid && <Form.Control.Feedback type="invalid" className="d-block">Please enter valid email</Form.Control.Feedback>}
                      </Col>
                    </Form.Row>
                  </Form>
                </Col>
                <Col>
                  <Schedule allowDonorSelect={this.state.allowDonorClinicSelect} clinic={this.state.clinic} schedule={this.state.schedule} onScheduleChange={this.onScheduleChange} defaultExpiration={this.defaultExpirationTime()}/>
                </Col>
              </Container>
            </Col>
          </Row>
          <Container fluid>
            <Row>
              <Col xs={12} md={6} lg={6} className="d-flex pt-2 pr-1">
                <Button hidden={this.state.step !== 1} onClick={this.onCancel} variant="secondary" className="mr-auto fixed-w10">CANCEL</Button>
                <Button hidden={this.state.step !== 2} onClick={this.onGoToStep1} variant="secondary" className="mr-auto fixed-w10">BACK</Button>
                <Button hidden={this.state.step !== 1} onClick={this.onGoToStep2} disabled={!isStep2Available} variant="primary" className="ml-auto fixed-w10">NEXT</Button>
                <ActionButton hidden={this.state.step !== 2} onClick={this.onSubmit} disabled={!isOrderCanBeSubmitted} spin={this.state.orderSubmitting} variant="primary" className="ml-auto fixed-w10" disableOnSpin>SUBMIT</ActionButton>
              </Col>
            </Row>
          </Container>
        </Container>
      </AppPageWrapper>
    </>)
  }
}

function mapStateToProps(state: AppState): OrderRequestAuthProps {
  return {
    isLocation: (GetSelectedAssignedClinic(state)?.LocationID || 0) > 0
  }
}
const ConnectedOrderRequest = connect(mapStateToProps, null)(OrderRequest)
export default ConnectedOrderRequest
